import { globalScope as root } from '@Sage/ssm-utils';

import {
    isDevEnvironmentSwitcherEnabled,
    loadDevEnvironment,
} from '../components/DevPopUp/environments';

if (isDevEnvironmentSwitcherEnabled()) loadDevEnvironment();

const getConfigurationFromEnvironment = (constant) => {
    if (root.hasOwnProperty('FM_CONFIG')) {
        if (root.FM_CONFIG.hasOwnProperty(constant)) {
            return root.FM_CONFIG[constant];
        }
    }

    switch (constant) {
        case 'ADMIN_API_URL':
            return process.env.ADMIN_API_URL || 'https://be-cfmsta.forcemanager.net/api';
        case 'ADMIN_URL':
            return process.env.ADMIN_URL || 'https://admin.forcemanager.net';
        case 'CFM_URL':
            return process.env.CFM_URL || 'https://cfm.forcemanager.net/Login.aspx';
        case 'WEBAPP_URL':
            return process.env.WEBAPP_URL || 'https://app.forcemanager.net';
        case 'BACKEND2_API_URL':
            return process.env.BACKEND2_API_URL || 'https://be-pro.forcemanager.net';
        case 'CHANGE_PSW_URL':
            return (
                process.env.CHANGE_PSW_URL ||
                'https://app.forcemanager.net/changepasswordemail.aspx'
            );
        case 'LITERALS_URL':
            return (
                process.env.LITERALS_URL ||
                'https://fm-literals.forcemanager.com/api/queries/commons/literalValues/literalValueObject?platform=107'
            );
        case 'CUSTOM_FUNC_IMPL':
            return process.env.CUSTOM_FUNC_IMPL
                ? process.env.CUSTOM_FUNC_IMPL.split(',').map((e) => Number(e.trim()))
                : [];
        case 'HIDE_LITERALS':
            return 'SHOW';
        case 'VERSION':
            return process.env.VERSION || 'DEVELOPMENT';
        default:
            throw new Error('Invalid configuration requested for ADMIN: ' + constant);
    }
};

export const ADMIN_API_URL = getConfigurationFromEnvironment('ADMIN_API_URL');
export const NODE_ENV = process.env.NODE_ENV;
const ADMIN_URL = getConfigurationFromEnvironment('ADMIN_URL');
const CFM_URL = getConfigurationFromEnvironment('CFM_URL');
export const WEBAPP_URL = getConfigurationFromEnvironment('WEBAPP_URL');
export const BACKEND2_API_URL = getConfigurationFromEnvironment('BACKEND2_API_URL');
const CHANGE_PSW_URL = getConfigurationFromEnvironment('CHANGE_PSW_URL');
export const LITERALS_URL = getConfigurationFromEnvironment('LITERALS_URL');
const CUSTOM_FUNC_IMPL = getConfigurationFromEnvironment('CUSTOM_FUNC_IMPL');
export const HIDE_LITERALS = getConfigurationFromEnvironment('HIDE_LITERALS');
const VERSION = getConfigurationFromEnvironment('VERSION');
